<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect7"><a id="page16"></a><span href="#/OEBPS/toc#sect7" title="Link target outside of Sample">Breakfast Stuffed Peppers</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/17-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 6 | Prep Time: 15 minutes | Cook Time: 45 minutes</p>
<p class="extract_r">Yes, stuffed peppers are typically made for dinner. But you find bell peppers in omelets and breakfast skillets, so why can’t you change the format of the ingredients to make a breakfast version of stuffed peppers? Plus, you get even more veggies than you normally would with each serving.</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">3 large red or yellow bell peppers (or a combination of colors)</p>
<p class="rec">½ pound ground turkey sausage</p>
<p class="rec">3 tablespoons olive oil</p>
<p class="rec">1–2 red potatoes, peeled and finely diced (1 cup)</p>
<p class="rec">1–2 sweet potatoes, peeled and finely diced (1 cup)</p>
<p class="rec">½ cup finely minced shallots</p>
<p class="rec">1 tablespoon minced garlic</p>
<p class="rec">1 tablespoon Italian seasoning</p>
<p class="rec">1 tablespoon fresh thyme</p>
<p class="rec">½ teaspoon kosher salt</p>
<p class="rec">¼ teaspoon freshly ground black pepper</p>
<p class="rec">1 tablespoon maple syrup</p>
<p class="rec">6 large eggs, whisked together</p>
<p class="rec">½ cup shredded low-fat Colby Jack cheese</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Preheat the oven to 375°F. Lightly coat a baking dish with cooking spray.</p>
<p class="recpr">2. Slice the peppers in half through the top of the stem. Remove the seeds and interior membrane. Rinse and dry the peppers. Place cut-side up in the baking dish.</p>
<p class="recpr">3. In a medium skillet, cook the sausage for about 3 minutes, until fully cooked. Remove to a large bowl.</p>
<p class="recpr">4. Wipe out the skillet, add the olive oil, and warm over medium-high heat.</p>
<p class="recpr">5. Add the red potatoes, sweet potatoes, and shallots. Then add the garlic, Italian seasoning, thyme, salt, and black pepper. Cook for 5 minutes.</p>
<p class="recpr">6. Remove the potato mixture from the heat and add to the bowl with the sausage. Mix in the maple syrup.</p>
<p class="recpr">7. Fill each pepper three-quarters full with the sausage and potato mixture.</p>
<p class="recpr">8. Add some of the whisked egg to the top of each of the peppers.</p>
<p class="recpr">9. Bake for 35 minutes or until the eggs have set.</p>
<p class="recpr">10. Sprinkle each pepper with the Colby Jack cheese. Serve.</p>
<p class="notehead"><strong>NOTES</strong></p>
<p class="NotebText">If the peppers will not sit up straight in the baking dish, place some crumpled foil between them to prop them up.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect7.vue?66148fd6